// Action enums
export enum ActionTypes {
  ADD_INFO_MESSAGE = "ADD_INFO_MESSAGE",
  ADD_SUCCESS_MESSAGE = "ADD_SUCCESS_MESSAGE",
  ADD_ERROR_MESSAGE = "ADD_ERROR_MESSAGE",
  HIDE_MESSAGE = "HIDE_MESSAGE",
}
